import React from 'react';

import uid from '../../../utils/uid';
import ImplicitFileInput, {
    ImplicitFileInputProps,
} from './core/ImplicitFileInput';
import './Upload.css';

interface UploadProps extends ImplicitFileInputProps {
    children?: React.ReactNode;
    id?: string;
}

const Upload: React.FC<UploadProps> = ({
    children = null,
    id,
    ...props
}) => {
    const uIdUpload = id || uid('file-input');

    const labelClick = (
        e: React.MouseEvent<HTMLLabelElement>
    ) => {
        if (e.target !== e.currentTarget) {
            e.currentTarget.click();
        }
    };

    return (
        <div className="Upload">
            <div>
                <label
                    htmlFor={uIdUpload}
                    onClick={labelClick}
                >
                    {children}
                </label>
            </div>

            <ImplicitFileInput
                {...props}
                id={uIdUpload}
            />
        </div>
    );
};

export default Upload;
